import { handleActions } from 'redux-actions';
import { UserInformation } from '@ha/api/v2/types/UserInformation';
import { Actions, LoadUserDonePayload } from '../constants';

export type State = Readonly<UserInformation>;

const initialState: State = {
  advertiserBookingsCount: 0,
  advertiserConversationsCount: 0,
  hasAvatar: false,
  hasFacebookProfile: false,
  hasPayoutChangesInProgress: false,
  hasPhone: false,
  hasProfileChangesInProgress: false,
  listingsCount: 0,
  savedPaymentMethodsCount: 0,
  savedPayoutMethodsCount: 0,
  tenantBookingsCount: 0,
  tenantConversationsCount: 0,
  isKYCDone: false,
};

const userInfoReducer = handleActions(
  {
    [Actions.LOAD_USER_DONE]: (state, action: LoadUserDonePayload) => ({
      ...state,
      ...action.payload.userInfo,
    }),
  },
  initialState,
);
export { userInfoReducer };
